import constant from 'constant';

function setUserSession() {
  sessionStorage.setItem(constant.SESSION_KEY_NAME, 'true');
}

function getUserSession() {
  return sessionStorage.getItem(constant.SESSION_KEY_NAME);
}

function clearUserSession() {
  sessionStorage.removeItem(constant.SESSION_KEY_NAME);
}

export default {
  setUserSession,
  getUserSession,
  clearUserSession,
};
